import { Theme, useTheme } from '@mui/material'
import { useMemo } from 'react'
import { ApplicationOrientation } from '../generated/apollo-operations'
import { useApplicationOrientation } from './useApplicationOrientation'

/**
 * Simulate MUI's now deprecated `makeStyles` hook.
 *
 * @param getStylesFn Function that takes a theme and additional props
 * @returns An object of styles that can be passed to the `sx` prop of a component.
 */
function useStyles<T extends object>(
  getStylesFn: (theme: Theme, orientation: ApplicationOrientation) => T,
) {
  const theme = useTheme()
  const { orientation } = useApplicationOrientation()

  return useMemo(() => getStylesFn(theme, orientation), [getStylesFn, theme, orientation])
}

export default useStyles
